export const accountState = {
  account: null,
  routeBeforeBlock: '/main/booking/',
}